'use strict';

export const FETCH_JOB = 'orders/FETCH_JOB';
export const FETCH_JOB_COMPLETED = 'orders/FETCH_JOB_COMPLETED';
export const GET_JOBS = 'orders/GET_JOBS';
export const GET_JOBS_COMPLETED = 'orders/GET_JOBS_COMPLETED';
export const FETCH_ASSIGNED = 'orders/FETCH_ASSIGNED';
export const FETCH_ASSIGNED_COMPLETED = 'orders/FETCH_ASSIGNED_COMPLETED';
export const POST_SERVE = 'orders/POST_SERVE';
export const POST_SERVE_COMPLETED = 'orders/POST_SERVE_COMPLETED';
export const POST_UNDO_SERVE = 'orders/POST_UNDO_SERVE';
export const POST_UNDO_SERVE_COMPLETED = 'orders/POST_UNDO_SERVE_COMPLETED';
export const POST_BAD_ADDRESS = 'orders/POST_BAD_ADDRESS';
export const POST_BAD_ADDRESS_COMPLETED = 'orders/POST_BAD_ADDRESS_COMPLETED';
export const POST_UNDO_BAD_ADDRESS = 'orders/POST_UNDO_BAD_ADDRESS';
export const POST_UNDO_BAD_ADDRESS_COMPLETED = 'orders/POST_UNDO_BAD_ADDRESS_COMPLETED';
export const POST_COMPLETE_TASK = 'orders/POST_COMPLETE_TASK';
export const POST_COMPLETE_TASK_COMPLETED = 'orders/POST_COMPLETE_TASK_COMPLETED';
export const POST_UNCOMPLETE_TASK = 'orders/POST_UNCOMPLETE_TASK';
export const POST_UNCOMPLETE_TASK_COMPLETED = 'orders/POST_UNCOMPLETE_TASK_COMPLETED';
export const POST_IMPORT_JOBS = 'orders/POST_IMPORT_JOBS';
export const POST_IMPORT_JOBS_COMPLETED = 'orders/POST_IMPORT_JOBS_COMPLETED';
export const POST_ASSIGN_JOBS = 'orders/POST_ASSIGN_JOBS';
export const POST_ASSIGN_JOBS_COMPLETED = 'orders/POST_ASSIGN_JOBS_COMPLETED';
